// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + "f87ac377" + ".chunk.css";
};